<template>
    <div class="form-container">
        <h2>{{ isEdit ? 'Edit Appointment' : 'Create Appointment' }}</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
        </div>
        <form @submit.prevent="saveAppointment">
            <label>Student <span class="required">*</span></label>
            <select v-model="appointment.student_id" class="form-control" required>
                <option value="">Select Student</option>
                <option v-for="student in students" :key="student.id" :value="student.id">
                    {{ student.user?.name }}
                </option>
            </select>
            <div v-if="errors.student_id" class="error-message">{{ errors.student_id[0] }}</div>

            <label>Counselor <span class="required">*</span></label>
            <select v-model="appointment.counselor_id" class="form-control" required>
                <option value="">Select Counselor</option>
                <option v-for="counselor in counselors" :key="counselor.id" :value="counselor.id">
                    {{ counselor.user?.name }}
                </option>
            </select>
            <div v-if="errors.counselor_id" class="error-message">{{ errors.counselor_id[0] }}</div>

            <label>Appointment Date <span class="required">*</span></label>
            <input type="date" v-model="appointment.appointment_date" class="form-control" required>
            <div v-if="errors.appointment_date" class="error-message">{{ errors.appointment_date[0] }}</div>

            <label>Time Slot <span class="required">*</span></label>
            <select v-model="appointment.time_slot_id" class="form-control" required>
                <option value="">Select Time Slot</option>
                <option v-for="slot in timeSlots" :key="slot.id" :value="slot.id">
                    {{ formatTime(slot.start_time) }} - {{ formatTime(slot.end_time) }}
                </option>
            </select>
            <div v-if="errors.time_slot_id" class="error-message">{{ errors.time_slot_id[0] }}</div>

            <label>Status</label>
            <select v-model="appointment.status" class="form-control">
                <option value="scheduled">Scheduled</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
                <option value="rescheduled">Rescheduled</option>
            </select>
            <div v-if="errors.status" class="error-message">{{ errors.status[0] }}</div>

            <label>Notes</label>
            <textarea v-model="appointment.notes" class="form-control" placeholder="Notes (optional)"></textarea>
            <div v-if="errors.notes" class="error-message">{{ errors.notes[0] }}</div>

            <div class="btn-group">
                <button type="submit" class="btn btn-sm">{{ isEdit ? 'Update' : 'Add' }}</button>
                <button type="button" class="btn btn-sm cancel-btn"
                    @click="$router.push('/dashboard/appointments')">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            appointment: {
                student_id: '',
                counselor_id: '',
                appointment_date: '',
                time_slot_id: '',
                status: 'scheduled',
                notes: ''
            },
            students: [],
            counselors: [],
            timeSlots: [],
            isEdit: false,
            errorMessage: null,
            errors: {}
        };
    },
    methods: {
        formatTime(time) {
            if (!time) return 'N/A';
            const [hours, minutes] = time.split(':');
            let h = parseInt(hours);
            const ampm = h >= 12 ? 'PM' : 'AM';
            h = h % 12 || 12; // Convert 0 to 12 for 12 AM
            return `${h}:${minutes} ${ampm}`;
        },
        async fetchAppointment() {
            if (this.$route.params.id) {
                this.isEdit = true;
                try {
                    const response = await this.$api.get(`/appointments/${this.$route.params.id}`);
                    this.appointment = response.data;
                } catch (error) {
                    this.errorMessage = 'Error fetching appointment data.';
                }
            }
        },
        async fetchStudents() {
            const res = await this.$api.get('/students');
            this.students = res.data;
        },
        async fetchCounselors() {
            const res = await this.$api.get('/counselors');
            this.counselors = res.data;
        },
        async fetchTimeSlots() {
            const res = await this.$api.get('/time-slots');
            this.timeSlots = res.data;
        },
        async saveAppointment() {
            this.errorMessage = null;
            this.errors = {};
            try {
                const apiCall = this.isEdit ? this.$api.put : this.$api.post;
                const url = this.isEdit ? `/appointments/${this.$route.params.id}` : '/appointments';
                await apiCall(url, this.appointment);
                this.$router.push('/dashboard/appointments');
            } catch (error) {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    this.errorMessage = 'An error occurred while saving the appointment. Please try again later.';
                }
            }
        }
    },
    mounted() {
        this.fetchAppointment();
        this.fetchStudents();
        this.fetchCounselors();
        this.fetchTimeSlots();
    }
};
</script>

<style scoped>
.form-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.error-message {
    color: red;
    font-size: 0.9rem;
}

.btn-group {
    margin-top: 10px;
}

.cancel-btn {
    margin-left: 10px;
}
</style>
